module.exports = __webpack_public_path__ + "1ddb1c382a089fab6401aa38aba6a9b0.jpg";